import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import React from 'react';
const SortTaskComponent = ({ title, hasOpenTasks, toggleOpenTasks, }) => (_jsxs("span", Object.assign({ className: "clickable", onClick: () => toggleOpenTasks() }, { children: [_jsx("i", { className: classnames('fa margin10R', hasOpenTasks ? 'fa-angle-double-up' : 'fa-angle-double-down') }), title] })));
export default SortTaskComponent;
